<template>
  <div class="pa-4">
    <div class="d-flex flex-row-reverse">
      <v-row align="center">
        <v-col class="py-0" cols="auto">
          <v-tabs slider-size="4" background-color="transparent" v-model="tab">
            <v-tab
              v-for="type in tabType"
              :key="type.key"
              :class="['title', $globalStyle.tabColor]"
              v-text="type.value"
              @click="$refs.unselectAll.click()"
            ></v-tab>
          </v-tabs>
        </v-col>
        <v-spacer class="py-0"></v-spacer>
        <v-col class="py-0" cols="6" md="5" lg="4" xl="3">
          <v-text-field
            v-model="search"
            background-color="white"
            outlined
            dense
            single-line
            rounded
            placeholder="搜尋寵物名、聯絡人、電話..."
            hide-details
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div class="d-flex flex-row-reverse mt-4">
      <v-scroll-y-transition group>
        <v-btn
          depressed
          dark
          :color="$classStyle.addBtn"
          v-if="selectRow.length === 0"
          key="add"
          @click="$refs.editDialog.create()"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="subtitle-1">新增</span>
        </v-btn>
        <v-btn
          depressed
          color="error"
          v-else
          key="delete"
          @click="$refs.deleteConfirmDialog.showForDeletePet(selectRow)"
        >
          <span class="subtitle-1">刪除</span>
        </v-btn>
      </v-scroll-y-transition>
    </div>
    <v-card outlined class="mt-4">
      <v-data-table
        :class="[$globalStyle['manage-table'], $globalStyle['cross-row']]"
        :search="search"
        show-select
        :headers="headers"
        :items="tableItems"
        hide-default-footer
        item-key="_id"
        :items-per-page="itemPerPage"
        :page="page"
        @input="selected => (selectRow = selected)"
        @current-items="items => (currentItems = items)"
        @click:row="
          item => $router.push({ path: `/petManage/petProfile/${item._id}/0` })
        "
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <span
              v-text="tableHint"
              :class="['body-2', $globalStyle.tableHeaderColor]"
            ></span>
            <v-spacer></v-spacer>
            <div class="d-inline-flex" outlined>
              <base-pagination
                v-model="page"
                :length="Math.ceil(tableItems.length / itemPerPage)"
              ></base-pagination>
            </div>
          </v-toolbar>
        </template>
        <template v-slot:header.data-table-select="{ props, on }">
          <div ref="unselectAll" @click="on.input(false)"></div>
          <v-checkbox
            color="cyan"
            hide-details
            class="mt-0"
            @click.stop="on.input(!props.value)"
            v-bind="props"
            v-on="on"
          ></v-checkbox>
        </template>
        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-checkbox
            color="cyan"
            hide-details
            :input-value="isSelected"
            @click.stop="select(!isSelected)"
            class="mt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="pointer black--text" v-text="item.name"></span>
        </template>
        <template v-slot:item.breed="{ item }">
          <span class="pointer black--text" v-text="item.breed"></span>
        </template>
        <template v-slot:item.gender="{ item }">
          <v-icon
            v-if="item.gender === 'male'"
            :color="$classStyle.genderMale"
            class="pointer"
            >mdi-gender-male</v-icon
          >
          <v-icon v-else :color="$classStyle.genderFemale" class="pointer"
            >mdi-gender-female</v-icon
          >
        </template>
        <template v-slot:item.birth="{ item }">
          <span
            class="pointer black--text"
            v-text="$common.parsePetAge(item.birth)"
          ></span>
        </template>
        <template v-slot:item.userName="{ item }">
          <span class="pointer black--text" v-text="item.userName"></span>
        </template>
        <template v-slot:item.userPhone="{ item }">
          <span class="pointer black--text" v-text="item.userPhone"></span>
        </template>
        <template v-slot:no-data>無資料</template>
      </v-data-table>
    </v-card>
    <dialog-edit-pet-profile
      ref="editDialog"
      @done="getAllPets"
    ></dialog-edit-pet-profile>
    <dialog-delete-confirm
      ref="deleteConfirmDialog"
      @done="deletePetFinish"
    ></dialog-delete-confirm>
  </div>
</template>

<script>
import DialogEditPetProfile from "./DialogEditPetProfile";
import DialogDeleteConfirm from "../common/DialogDeleteConfirm";

import BasePagination from "../common/BasePagination";

export default {
  components: {
    DialogEditPetProfile,
    DialogDeleteConfirm,
    BasePagination
  },
  data: () => ({
    page: 1,
    itemPerPage: 10,
    selectRow: [],
    currentItems: [],
    tabType: [
      {
        key: "all",
        value: "全部"
      },
      {
        key: "cat",
        value: "貓咪"
      },
      {
        key: "dog",
        value: "狗狗"
      },
      {
        key: "other",
        value: "其他"
      }
    ],
    tab: 0,
    headers: [
      {
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"],
        text: "寵物名",
        value: "name"
      },
      {
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"],
        text: "品種",
        value: "breed"
      },
      {
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"],
        text: "性別",
        value: "gender"
      },
      {
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"],
        text: "年齡",
        value: "birth"
      },
      {
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"],
        text: "聯絡人",
        value: "userName"
      },
      {
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"],
        text: "聯絡電話",
        value: "userPhone"
      }
    ],
    petItems: [],
    search: ""
  }),
  computed: {
    tableHint() {
      if (this.selectRow.length > 0) {
        return `已選取${this.selectRow.length}隻寵物`;
      } else {
        let start = (this.page - 1) * this.itemPerPage + 1;
        let end = start + this.currentItems.length - 1;
        return `${start}-${end}筆,共${this.tableItems.length}筆資料`;
      }
    },
    tableItems() {
      let type = this.tabType[this.tab].key;
      console.log("type:" + type);
      if (type === "all") {
        return this.petItems;
      } else {
        return this.petItems.filter(item => {
          return item.type === type;
        });
      }
    }
  },
  methods: {
    async getAllPets() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/pets/0/0`
      );
      //console.log("response:" + JSON.stringify(response.data));
      this.petItems = response.data;
    },
    deletePetFinish() {
      this.$refs.unselectAll.click();
      this.getAllPets();
    }
  },
  mounted() {
    this.getAllPets();
  }
};
</script>
